import type { ComponentProps, ReactElement } from "react";
import {
  Button,
  Checkbox,
  EditableDescription,
  EditableHeading,
  EditableText,
  IconButton,
  MenuButton,
  MenuItem,
  Radio,
  Select,
  type SelectProps,
  SplitButton,
  Switch,
} from "@hightouch/htui";

import { DeleteButton } from "src/components/delete-button";
import { LinkButton } from "src/router";

import { withPermission } from "./with-permission";

export const PermissionedButton = withPermission(Button);
export const PermissionedSplitButton = withPermission(SplitButton);
export const PermissionedLinkButton = withPermission(LinkButton);
export const PermissionedMenuItem = withPermission(MenuItem);
export const PermissionedMenuButton = withPermission(MenuButton);
export const PermissionedIconButton = withPermission(IconButton);
export const PermissionedSwitch = withPermission(Switch);
export const PermissionedEditableHeading = withPermission(
  EditableHeading,
  // The edit icon is invisible when unauthorized, so the tooltip isn't necessary
  { disableUnauthorizedTooltip: true },
);
export const PermissionedEditableDescription = withPermission(
  EditableDescription,
  // The edit icon is invisible when unauthorized, so the tooltip isn't necessary
  { disableUnauthorizedTooltip: true },
);
export const PermissionedEditableText = withPermission(
  EditableText,
  // The edit icon is invisible when unauthorized, so the tooltip isn't necessary
  { disableUnauthorizedTooltip: true },
);
export const PermissionedCheckbox = withPermission(Checkbox);
export const PermissionedRadio = withPermission(Radio);
const PermissionedSelectBase = withPermission(Select);
// Preserve Select's option/value inference through the permission wrapper.
export const PermissionedSelect = PermissionedSelectBase as <
  Option,
  OptionValue extends Option[keyof Option],
>(
  props: Omit<
    ComponentProps<typeof PermissionedSelectBase>,
    keyof SelectProps<Option, OptionValue>
  > &
    SelectProps<Option, OptionValue>,
) => ReactElement | null;
export const PermissionedDeleteButton = withPermission(DeleteButton);
